import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import SpinnerLoading from "../Common/SpinnerLoading";
import { useHistory } from "react-router-dom";
import { storeService } from "../../Services/store.service";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const StoreDetailTab = ({ storeId }) => {
  const { t: translator } = useTranslation();
  const { updateLocTab, locTab } = useContext(GlobalContext);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [store, setStore] = useState();

  useEffect(() => {
    if (locTab === "stores") {
      storeService
        .getById(storeId)
        .then(res => {
          setStore(res.data);
          setIsLoading(false);
        })
        .catch(err => console.log(err.response));
    }
  }, [locTab]);

  const handleToDetail = () => {
    updateLocTab("tenants");
    history.push(`/stores/${storeId}`);
  };

  return (
    <>
      {isLoading && <SpinnerLoading />}
      {!isLoading && store && (
        <div className="col-lg-5">
          <div className="custom-card m-2 mt-5">
            <div className="custom-card-header">
              <h3>
                {store.description}{" "}
                <span className="button-edit">
                  <span
                    onClick={handleToDetail}
                    title={translator("StoreDetailTab-DetailsIcon")}
                    className="icon icon-information"></span>
                </span>
              </h3>
              <hr />
            </div>
            <div className="custom-card-body">
              <p>
                <strong>{translator("Store-StoreDetail-Tag")}: </strong>
                {store.tag}
              </p>
              <p>
                <span>
                  <strong>{translator("Store-StoreDetail-Street")}:</strong>{" "}
                  {store.street} {store.streetNumber}
                  {store.streetNumberExtension}
                </span>
                <br />
                <span>
                  <strong>{translator("Store-StoreDetail-City")}:</strong>{" "}
                  {store.postalNumber}, {store.city}
                </span>
              </p>
            </div>
            <div className="custom-card-footer"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default StoreDetailTab;
